module.exports = __webpack_public_path__ + "components/frontend-templates/frontendHtmlAngular/frontend-html-angular.tpl.php";